export default __webpack_public_path__ + "static/media/reportImage.9571edd9.svg";